<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 272 303"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="filter0_ddddd_16_8532" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="583" width="272" x="0" y="0">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.329412 0 0 0 0 0.278431 0 0 0 0 0.0313726 0 0 0 0.1 0"/>
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_16_8532"/>
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="8"/>
        <feGaussianBlur stdDeviation="9"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.329412 0 0 0 0 0.278431 0 0 0 0 0.0313726 0 0 0 0.1 0"/>
        <feBlend in2="effect1_dropShadow_16_8532" mode="normal" result="effect2_dropShadow_16_8532"/>
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="32"/>
        <feGaussianBlur stdDeviation="16"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.329412 0 0 0 0 0.278431 0 0 0 0 0.0313726 0 0 0 0.09 0"/>
        <feBlend in2="effect2_dropShadow_16_8532" mode="normal" result="effect3_dropShadow_16_8532"/>
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="73"/>
        <feGaussianBlur stdDeviation="22"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.329412 0 0 0 0 0.278431 0 0 0 0 0.0313726 0 0 0 0.05 0"/>
        <feBlend in2="effect3_dropShadow_16_8532" mode="normal" result="effect4_dropShadow_16_8532"/>
        <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="130"/>
        <feGaussianBlur stdDeviation="26"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.329412 0 0 0 0 0.278431 0 0 0 0 0.0313726 0 0 0 0.01 0"/>
        <feBlend in2="effect4_dropShadow_16_8532" mode="normal" result="effect5_dropShadow_16_8532"/>
        <feBlend in="SourceGraphic" in2="effect5_dropShadow_16_8532" mode="normal" result="shape"/>
      </filter>
      <linearGradient id="paint0_linear_16_8532" gradientUnits="userSpaceOnUse" x1="136" x2="136" y1="259.5" y2="401">
        <stop stop-opacity="0"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_16_8532" gradientUnits="userSpaceOnUse" x1="136" x2="136" y1="40.5" y2="141">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'PwccFlat',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
};

</script>
